// extracted by mini-css-extract-plugin
export var aboveInput = "_ha-0";
export var actionButton = "_ha-5";
export var actionButtonContainer = "_ha-1";
export var actionIcon = "_ha-6";
export var aiInfoContainer = "_ha-2";
export var attachmentWrapper = "_ha-7";
export var bold = "_ha-3";
export var checkIcon = "_ha-8";
export var clickingRecipientBar = "_ha-11";
export var commentThreadSwitch = "_ha-a";
export var draftImage = "_ha-b";
export var draftImageContainer = "_ha-c";
export var draftImages = "_ha-e";
export var editButton = "_ha-g";
export var editor = "_ha-f";
export var editorContainer = "_ha-y";
export var editorErrorTooltipWrapper = "_ha-9";
export var headerDivider = "_ha-h";
export var icon = "_ha-i";
export var info = "_ha-j";
export var internal = "_ha-n";
export var internalDivider = "_ha-k";
export var internalMessage = "_ha-l";
export var messageInputCard = "_ha-m";
export var messageInputForm = "_ha-o";
export var messageInputFormInternal = "_ha-p";
export var options = "_ha-q";
export var publicMessageCustomer = "_ha-s";
export var publicMessageMerchant = "_ha-r";
export var removeImageButton = "_ha-d";
export var replyButtons = "_ha-t";
export var showSignatureButton = "_ha-u";
export var spinner = "_ha-v";
export var verticalButtonDivider = "_ha-4";
export var visibilitySelector = "_ha-w";
export var warning = "_ha-x";
export var wrappingText = "_ha-z";
export var writingInternalNoteTopBorder = "_ha-10";